import { TokenManager } from '../components/TokenManager';
import { usePaletteContext } from '../contexts/PaletteContext';
import { TokenPreview } from '../components/palette/TokenPreview';

function PaletteTokenSection() {
  const { currentPalette } = usePaletteContext();

  if (!currentPalette) return null;

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Palette Tokens — {currentPalette.name}
      </h3>
      <TokenPreview palette={currentPalette} />
    </div>
  );
}

export function TokensTool() {
  return (
    <div className="w-full max-w-4xl mx-auto p-6 space-y-6">
      <TokenManager />
      <PaletteTokenSection />
    </div>
  );
}
